<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat class="card-border">
          <h2>Просмотр заявок на товары</h2>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-card flat tile>
          <v-card-text>
            <v-toolbar flat dense>
              <v-menu offset-y bottom>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mx-3"
                    label="Выберите дату"
                    v-model="day"
                    v-on="on"
                    :disabled="inAction"
                    style="max-width: 220px"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  :disabled="inAction" locale="ru" first-day-of-week="1"
                  v-model="day" :landscape="true" :reactive="true"
                ></v-date-picker>
              </v-menu>
              <v-btn
                color="primary"
                class="mx-5"
                :disabled="inAction || !day"
                @click="fetch()"
              >Посмотреть</v-btn>
              <v-btn
                v-if="items.length > 0"
                color="primary"
                class="mx-5"
                :disabled="inAction"
                @click="saveAs()"
              >
                <v-icon>save</v-icon> Сохранить
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="secondary" icon fab @click="openAddDialog()">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn color="green darken-1" icon fab @click="openViewerDialog()">
                <v-icon>visibility</v-icon>
              </v-btn>
            </v-toolbar>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <div style="text-align:center">
              <span v-if="items.length === 0">Нет данных</span>
            </div>
            <template>
              <v-treeview
                dense
                :items="items"
              >
                <template v-slot:label="{ item }">
                  <span v-if="item.quantity && item.unit"><strong>[{{ item.quantity }} {{ item.unit }}] </strong></span>{{ item.name }}
                </template>
              </v-treeview>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog
        v-model="addGoodsDialog"
        persistent :overlay="false"
        max-width="800px"
        transition="dialog-transition"
      >
        <v-card>
          <v-toolbar color="grey lighten-4" flat tile class="pr-1">
            <v-toolbar-title>Добавление товара</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="red" icon @click="closeAddDialog()" class="">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-layout column>
            <v-layout row class="px-2 mx-0">
              <v-flex xs11>
                <v-autocomplete
                  label="Категория товаров"
                  :items="goodsgroups"
                  item-text="title"
                  item-value="id"
                  v-model="newGoods.groupid"
                  :disabled="addGroup || addType"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs1 class="pl-3">
                <v-btn :disabled="addGroup || addType" color="secondary" icon fab @click="openAddGroupDialog()">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-card v-if="addGroup" dark class="px-2">
              <v-card-title primary-title>
                Добавление категории товаров
              </v-card-title>
              <v-text-field
                v-if="addGroup"
                v-model="newTitle"
                label="Введите название категории товаров"
              ></v-text-field>
              <v-card-actions>
                <v-btn v-if="addGroup" color="primary" @click="addGroup=false;newTitle='';">
                  Отмена
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="addGroup" color="primary" @click="addGoodsGroup()">
                  Сохранить
                </v-btn>
              </v-card-actions>
            </v-card>

            <v-layout row class="px-2 mx-0">
              <v-flex xs11>
                <v-autocomplete
                  label="Тип питания"
                  :disabled="addGroup || addType"
                  :items="goodstypes"
                  item-text="title"
                  item-value="id"
                  v-model="newGoods.typeid"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs1 class="pl-3">
                <v-btn :disabled="addType || addGroup" color="secondary" icon fab @click="openAddTypeDialog()">
                  <v-icon>add</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>

            <v-card v-if="addType" dark class="px-2">
              <v-card-title primary-title>
                Добавление типа питания
              </v-card-title>
              <v-text-field
                v-if="addType"
                v-model="newTitle"
                label="Введите название типа питания"
              ></v-text-field>
              <v-card-actions>
                <v-btn v-if="addType" color="primary" @click="addType=false;newTitle='';">
                  Отмена
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="addType" color="primary" @click="addGoodsType()">
                  Сохранить
                </v-btn>
              </v-card-actions>
            </v-card>

            <v-layout row class="px-2 mx-0">
              <v-flex xs9>
                <v-text-field
                  v-model="newGoods.title"
                  :disabled="addGroup || addType"
                  label="Наименование товара"
                  class="pr-4"
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-select
                  :disabled="addGroup || addType"
                  :items="['кг', 'шт', 'л']"
                  v-model="newGoods.unit"
                  label="Единица измерения"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-layout>
          <v-card-actions>
            <v-btn color="primary" @click="closeAddDialog()">
              Отмена
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!newGoods.title || !newGoods.groupid || !newGoods.typeid || !newGoods.unit"
              color="primary"
              @click="addGoods()"
            >
              Добавить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="goodsViewerDialog"
        fullscreen
        persistent
        :overlay="false"
        transition="dialog-transition"
      >
        <v-card>
          <v-toolbar color="grey lighten-4" flat tile class="pr-1">
            <v-toolbar-title>Просмотр списка продуктов</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="red" icon @click="closeViewerDialog()" class="">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-toolbar class="my-2 mx-2">
            <v-text-field
              v-model="search"
              placeholder="Поиск"
              style="width:300px"
              append-icon="search"
              class="shrink"
            ></v-text-field>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="filtered || []"
            :search="search"
            :footer-props="footerProps"
            no-data-text="пусто"
            no-results-text="ничего не найдено"
            :items-per-page.sync="itemsPerPage"
            class="elevation-1"
            item-key="id"
            loading="true"
            dense
          />
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
let builder = require('xmlbuilder')
const FileSaver = require('file-saver')

export default {
  name: 'Goods',
  data: () => ({
    day: null,
    inAction: false,
    progress: 0,
    items: [],
    xml: null,
    xmlfilename: null,
    addGoodsDialog: false,

    goodsViewerDialog: false,
    filtered: [],
    search: '',
    headers: [
      { text: 'Наименование', value: 'name' },
      { text: 'Категория', value: 'group' },
      { text: 'Тип питания', value: 'type' },
      { text: 'Единица измерения', value: 'unit' },
    ],
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 20, 30, 50, 100, { text: 'Все', value: -1 } ]
    },
    itemsPerPage: 20,

    goodsgroups: [],
    goodstypes: [],
    addGroup: false,
    addType: false,
    newTitle: '',
    newGoods: {
      title: '',
      groupid: null,
      typeid: null,
      unit: null
    }
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    orgid () {
      return this.profile ? this.profile.orgid : null
    }
  },
  watch: {
    day () {
      this.items = []
      this.inAction = false
    }
  },
  methods: {
    asyncTimeout (to) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, to)
      })
    },
    async fetch () {
      try {
        this.items = []
        const day = this.day
        if (!day) throw new Error('Выберите дату')
        this.progress = 1
        this.inAction = true
        await this.asyncTimeout(500)
        const { requests } = await this.$store.dispatch('sioRequest', {
          topic: 'org-goodsrequests',
          pl: { day }
        })
        requests.forEach(x => {
          this.items.push({
            name: x.cafe,
            cafeid: x.cafeid,
            children: x.goodsgroups.map(gg => {
              return {
                name: gg.title,
                children: gg.goodstypes.map(gt => {
                  return {
                    name: gt.title,
                    children: gt.values.map(v => {
                      return {
                        name: v.title,
                        unit: v.unit,
                        quantity: v.quantity
                      }
                    })
                  }
                })
              }
            })
          })
        })
      } catch (err) {
        console.error(err)
        this.$store.dispatch('snack', err)
      } finally {
        this.inAction = false
      }
    },
    async makeReport () {
      try {
        this.progress = 1
        this.inAction = true
        await this.asyncTimeout(500)
        var root = builder.create('Столовые')
        for (let item of this.items) {
          const nodeCafe = root.ele('Столовая')
          nodeCafe.ele('Код', null, item.cafeid)
          nodeCafe.ele('Наименование', null, item.name)
          const nodeGroups = nodeCafe.ele('КатегорииТоваров')
          for (let g of item.children) {
            const nodeGroup = nodeGroups.ele('Категория')
            nodeGroup.ele('Наименование', null, g.name)
            const nodeTypes = nodeGroup.ele('ТипыПитания')
            for (let t of g.children) {
              const nodeType = nodeTypes.ele('ТипПитания')
              nodeType.ele('Наименование', null, t.name)
              const nodeGoods = nodeType.ele('Товары')
              for (let p of t.children) {
                const nodeGood = nodeGoods.ele('Товар')
                nodeGood.ele('Наименование', null, p.name)
                nodeGood.ele('ЕдиницаИзмерения', null, p.unit)
                nodeGood.ele('Количество', null, p.quantity)
              }
            }
          }
        }
        const xml = root.end({ pretty: true })
        this.xml = xml.split('<?xml version="1.0"?>').join('<?xml version="1.0" encoding="UTF-8"?>')
        this.xmlfilename = `${this.orgid}-${this.day}.xml`
      } catch (error) {
        this.$store.dispatch('snack', error)
      } finally {
        this.progress = 0
        this.inAction = false
      }
    },
    async saveAs () {
      this.xml = null
      this.xmlfilename = null
      await this.makeReport()
      if (this.xml && this.xmlfilename) {
        const file = new File(
          [this.xml],
          this.xmlfilename,
          { type: 'text/plain;charset=utf-8' }
        )
        FileSaver.saveAs(file)
      }
    },
    async fetchGoodsGroups () {
      try {
        const { goodsgroups } = await this.$store.dispatch('sioRequest', {
          topic: 'org-goodsgroups',
          pl: {}
        })
        this.goodsgroups = goodsgroups
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchGoodsTypes () {
      try {
        const { goodstypes } = await this.$store.dispatch('sioRequest', {
          topic: 'org-goodstypes',
          pl: {}
        })
        this.goodstypes = goodstypes
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async openAddDialog () {
      await Promise.all([
        this.fetchGoodsGroups(),
        this.fetchGoodsTypes()
      ])
      this.addGoodsDialog = true
    },
    closeAddDialog () {
      this.newGoods.title = ''
      this.newGoods.typeid = null
      this.newGoods.groupid = null
      this.newGoods.unit = null
      this.addGoodsDialog = false
      this.addGroup = false
      this.addType = false
      this.newTitle = ''
    },
    openAddGroupDialog () {
      this.addGroupDialog = true
      this.addGroup = true
    },
    async addGoodsGroup () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-goodsgroups-add',
          pl: {
            title: this.newTitle
          }
        })
        this.$store.dispatch('snack', meta.msg)
        await this.fetchGoodsGroups()
      } catch (error) {
        this.$store.dispatch('snack', error)
      } finally {
        this.addGroup = false
        this.newTitle = ''
      }
    },
    openAddTypeDialog () {
      this.addTypeDialog = true
      this.addType = true
    },
    async addGoodsType () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-goodstypes-add',
          pl: {
            title: this.newTitle
          }
        })
        this.$store.dispatch('snack', meta.msg)
        await this.fetchGoodsTypes()
      } catch (error) {
        this.$store.dispatch('snack', error)
      } finally {
        this.addType = false
        this.newTitle = ''
      }
    },
    async addGoods () {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'org-goods-add',
          pl: this.newGoods
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (error) {
        this.$store.dispatch('snack', error)
      } finally {
        this.closeDialog()
      }
    },
    async fetchGoods () {
      const { goods } = await this.$store.dispatch('sioRequest', {
        topic: 'org-goods',
        pl: {}
      })
      this.filtered = goods.map(x => {
        return {
          name: x.title,
          group: this.goodsgroups.find(gg => gg.id === x.groupid).title || '',
          type: this.goodstypes.find(gt => gt.id === x.typeid).title || '',
          unit: x.unit
        }
      })
    },
    async openViewerDialog () {
      await Promise.all([
        this.fetchGoodsGroups(),
        this.fetchGoodsTypes(),
        this.fetchGoods()
      ])
      this.goodsViewerDialog = true
    },
    closeViewerDialog () {
      this.filtered = []
      this.search = ''
      this.goodsViewerDialog = false
    },

  }
}
</script>
